<template lang="pug">
#modal-editar-nota-de-pesagem
    el-dialog(
        width='600px',
        title='Editar',
        :visible.sync='mostrar',
        :close-on-click-modal='false',
        :before-close='fechar'
    )
        el-form(label-position='top')
            el-row(:gutter="20")
                el-col(:span="12")
                    el-form-item
                        template(slot='label')
                            span Numero da ordem de corte

                        el-input(v-model='numeroOrdemCorte', placeholder='Numero da ordem de corte', type='number')
                el-col(:span="12")
                    el-form-item
                        template(slot='label')
                            span Fazenda

                        el-input(v-model='codigoFazenda', placeholder='Fazenda')
            
            el-row(:gutter="20")
                el-col(:span="12")
                    el-form-item
                        template(slot='label')
                            span Código de Liberação

                        el-input(v-model='codigoLiberacao', maxlength='200', placeholder='Código de Liberação')
                
                el-col(:span="12")
                    el-form-item
                        template(slot='label')
                            span Peso líquido (t)

                        el-input(v-model='pesoLiquido', maxlength='200', placeholder='Peso líquido (t)', type='number')
            
            el-row(:gutter="20")
                el-col(:span="12")
                    el-form-item
                        template(slot='label')
                            span Número do Lote de controle

                        el-input(v-model='numeroLoteControle', maxlength='200', placeholder='Número do Lote de controle', type='number')
                el-col(:span="12")
                    el-form-item
                        template(slot='label')
                            span Data de entrada na usina

                        el-date-picker(
                            v-model='dataEntrada',
                            placement='bottom-start',
                            type='date',
                            placeholder='Data de entrada na usina',
                            format='dd/MM/yyyy'
                        )

        footer.espaco(slot='footer')
            BaseButton(type='default', @click='fechar') Cancelar

            BaseButton(
                type='primary',
                @click='salvar'
                :disabled='!checkCamposValidos()',
            ) Salvar

</template>

<script>
import RastreabilidadeNotaDePesagemService from '@/services/RastreabilidadeNotaDePesagemService';
import BaseButton from '@/components/vegaComponents/BaseButton.vue';

export default {
    name: 'ModalEditarNotaDePesagem',
    components: {
        BaseButton
    },
    emits: ['atualizarDados'],
    props: {
        mostrar: {
            type: Boolean,
            required: true
        },

        editar: {
            type: Boolean,
            required: false,
            default: false
        },

        dados: {
            type: Object,
            required: false,
            default: null
        }
    },

    data() {
        return {
            id: '',
            numeroOrdemCorte: '',
            codigoFazenda: '',
            codigoLiberacao: '',
            pesoLiquido: '',
            numeroLoteControle: '',
            dataEntrada: ''
        };
    },

    watch: {
        mostrar() {
            if (this.dados) {
                this.id = this.dados.id;
                this.numeroOrdemCorte = this.dados.numeroOrdemCorte;
                this.codigoFazenda = this.dados.codigoFazenda;
                this.codigoLiberacao = this.dados.codigoLiberacao;
                this.pesoLiquido = this.dados.pesoLiquido;
                this.numeroLoteControle = this.dados.numeroLoteControle;

                let dataSplit = this.dados.dataEntrada.split('/');
                let padraoDatePicker = `${dataSplit[1]}/${dataSplit[0]}/${dataSplit[2]}`;

                this.dataEntrada = new Date(padraoDatePicker);
            }
        }
    },

    methods: {
        fechar() {
            this.id = '';
            this.numeroOrdemCorte = '';
            this.codigoFazenda = '';
            this.codigoLiberacao = '';
            this.pesoLiquido = '';
            this.numeroLoteControle = '';
            this.dataEntrada = '';

            this.$emit('fechar');
        },

        atualizarListaRepresentantes() {
            this.$emit('atualizarListaRepresentantes');
        },

        checkCamposValidos() {
            if (
                this.numeroOrdemCorte !== '' &
                this.codigoFazenda !== '' &
                this.codigoLiberacao !== '' &
                this.pesoLiquido !== '' &
                this.numeroLoteControle !== '' &
                this.dataEntrada !== ''
                ) {
                    return true;
                }

            return false;
        },

        async salvar() {
            try {
                await RastreabilidadeNotaDePesagemService.editarNotaDePesagem({
                    id: this.dados.id,
                    numeroOrdemCorte: this.numeroOrdemCorte,
                    codigoFazenda: this.codigoFazenda,
                    codigoLiberacao: this.codigoLiberacao,
                    pesoLiquido: this.pesoLiquido,
                    numeroLoteControle: this.numeroLoteControle,
                    dataEntrada: this.dataEntrada.toLocaleDateString('pt-BR')
                });

                this.fechar();
                this.$emit('atualizarDados');

                this.$notify.success({
                    message: 'Nota de Pesagem editada com sucesso'
                });
            } catch (e) {
                this.$notify.error({
                    message: e.response.data.message
                });
            }
        }
    }
};
</script>

<style lang="scss">
footer {
    display: flex;
    justify-content: space-between;
}

.invalido {
    color: var(--danger);
}

.espaco {
    display: flex;
}

.el-date-editor.el-input {
    width: 100%;
}
</style>
